// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"d3e2a5cd","453":"926f0775","537":"7c74b334"}[chunkId] + ".chunk.js";
};